import type { Listing } from '../domain/types';

const now = new Date('2026-06-18T10:00:00.000Z').toISOString();

function listing(
  id: string,
  type: Listing['type'],
  dwellingsCount: number,
  formatted: string,
  street: string,
  number: string,
  postalCode: string,
  locality: string,
  province: string,
  lat: number,
  lng: number,
  cityId: string,
  neighborhoodId: string,
  extras: Partial<Listing> = {},
): Listing {
  return {
    id,
    type,
    dwellingsCount,
    address: { formatted, street, number, postalCode, locality, province },
    location: { lat, lng },
    neighborhoodId,
    cityId,
    streetView: { available: false, panoId: null, heading: null },
    evidence: { licenseNumber: null, platform: null, note: null },
    status: 'active',
    confirmations: 3,
    reports: 0,
    createdAt: now,
    updatedAt: now,
    ...extras,
  };
}

export const DEMO_LISTINGS: Listing[] = [
  listing(
    'demo-vlc-1',
    'building',
    12,
    'Carrer de Cadis, 42, 46006 València',
    'Carrer de Cadis',
    '42',
    '46006',
    'València',
    'València',
    39.46174,
    -0.37322,
    'valencia',
    'russafa',
    { confirmations: 18, evidence: { licenseNumber: null, platform: 'booking', note: null } },
  ),
  listing(
    'demo-vlc-2',
    'unit',
    1,
    'Carrer de Sueca, 31, 46006 València',
    'Carrer de Sueca',
    '31',
    '46006',
    'València',
    'València',
    39.46318,
    -0.37544,
    'valencia',
    'russafa',
    { confirmations: 9, evidence: { licenseNumber: 'VT-49123-V', platform: 'airbnb', note: null } },
  ),
  listing(
    'demo-vlc-3',
    'building',
    8,
    'Carrer de Cuba, 17, 46006 València',
    'Carrer de Cuba',
    '17',
    '46006',
    'València',
    'València',
    39.45994,
    -0.3767,
    'valencia',
    'russafa',
    { confirmations: 6 },
  ),
  listing(
    'demo-vlc-4',
    'unit',
    1,
    'Carrer de Dénia, 54, 46006 València',
    'Carrer de Dénia',
    '54',
    '46006',
    'València',
    'València',
    39.4608,
    -0.37042,
    'valencia',
    'russafa',
    { status: 'flagged', confirmations: 1, reports: 5 },
  ),
  listing(
    'demo-mad-1',
    'building',
    9,
    'Calle del Mesón de Paredes, 22, 28012 Madrid',
    'Calle del Mesón de Paredes',
    '22',
    '28012',
    'Madrid',
    'Madrid',
    40.40926,
    -3.70349,
    'madrid',
    'lavapies',
    { confirmations: 14 },
  ),
  listing(
    'demo-mad-2',
    'unit',
    1,
    'Calle de la Fe, 8, 28012 Madrid',
    'Calle de la Fe',
    '8',
    '28012',
    'Madrid',
    'Madrid',
    40.40816,
    -3.69911,
    'madrid',
    'lavapies',
    { confirmations: 7 },
  ),
  listing(
    'demo-bcn-1',
    'building',
    16,
    'Carrer de Verdi, 64, 08012 Barcelona',
    'Carrer de Verdi',
    '64',
    '08012',
    'Barcelona',
    'Barcelona',
    41.40425,
    2.15674,
    'barcelona',
    'gracia',
    { confirmations: 21 },
  ),
  listing(
    'demo-bcn-2',
    'unit',
    1,
    "Carrer de l'Or, 19, 08012 Barcelona",
    "Carrer de l'Or",
    '19',
    '08012',
    'Barcelona',
    'Barcelona',
    41.40214,
    2.15877,
    'barcelona',
    'gracia',
    { confirmations: 4 },
  ),
];
